import script from "./StudentAddressInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./StudentAddressInput.vue?vue&type=script&setup=true&lang=ts"

import "@/styles/baseformfield.scss?vue&type=style&index=0&id=36948784&scoped=true&lang=scss"
import "@/styles/address2.css?vue&type=style&index=1&id=36948784&scoped=true&lang=css"
import "@/styles/student/student-information-form.css?vue&type=style&index=2&id=36948784&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36948784"]])

export default __exports__